import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import BarChart from "@arelia-components/ui-atoms/BarChart";
import { Box } from "@mui/system";

type Props = {
  chartData: {
    label: string;
    value: number;
  }[];
  getTooltip: (v: { dataIndex: number }[]) => string;
  loading: boolean;
  error: boolean;
  unconnected: boolean;
};

export default function InteractionsPresenter({
  chartData,
  getTooltip,
  loading,
  error,
  unconnected
}: Props) {

  return (
    <WidgetCard
      widgetId="SOCIAL_INTERACTIONS"
      title="Social Interactions"
      loading={loading}
      error={error}
      unconnected={unconnected}
    >
      <Box flexGrow="1">
        <BarChart data={chartData} getTooltip={getTooltip} />
      </Box>
    </WidgetCard>
  );
}
